import { DesignSystem } from '@microsoft/fast-foundation';
export const provideChameleonDesignSystem = (element) => {
    return DesignSystem.getOrCreate(element).withPrefix('chameleon');
};
